import { ArrowLeft, Volume2, VolumeX, Globe, Star } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useGame } from "@/context/GameContext";
import { playSfx } from "@/lib/sounds";

export default function TopBar({ themeColor = "#38BDF8", title = "", showStars = true }) {
  const navigate = useNavigate();
  const { language, soundOn, toggleSound, toggleLanguage, stars } = useGame();

  const handleBack = () => {
    playSfx("tap", soundOn);
    navigate("/");
  };

  return (
    <div className="w-full flex items-center justify-between p-4 sm:p-6 z-10 relative">
      <button
        onClick={handleBack}
        className="toy-btn w-14 h-14 sm:w-16 sm:h-16 rounded-full bg-white flex items-center justify-center shadow-[0_5px_0_rgba(0,0,0,0.15)]"
        data-testid="top-bar-back"
        aria-label="Back"
      >
        <ArrowLeft className="w-7 h-7" strokeWidth={3} style={{ color: themeColor }} />
      </button>

      {title && (
        <div
          className="font-display font-bold text-xl sm:text-3xl px-4 py-2 rounded-full bg-white/80 backdrop-blur"
          style={{ color: themeColor }}
        >
          {title}
        </div>
      )}

      <div className="flex items-center gap-2 sm:gap-3">
        {showStars && (
          <div
            className="flex items-center gap-1 px-3 py-2 rounded-full bg-yellow-400 shadow-[0_4px_0_#ca8a04] font-display font-bold text-white"
            data-testid="stars-count"
          >
            <Star className="w-5 h-5 fill-white" strokeWidth={3} />
            <span>{stars}</span>
          </div>
        )}
        <button
          onClick={() => {
            toggleSound();
            playSfx("tap", !soundOn);
          }}
          className="toy-btn w-12 h-12 sm:w-14 sm:h-14 rounded-full bg-white flex items-center justify-center shadow-[0_4px_0_rgba(0,0,0,0.15)]"
          data-testid="toggle-sound"
          aria-label="Toggle sound"
        >
          {soundOn ? (
            <Volume2 className="w-6 h-6" strokeWidth={3} style={{ color: themeColor }} />
          ) : (
            <VolumeX className="w-6 h-6 text-slate-400" strokeWidth={3} />
          )}
        </button>
        <button
          onClick={toggleLanguage}
          className="toy-btn h-12 sm:h-14 px-3 rounded-full bg-white flex items-center gap-1 shadow-[0_4px_0_rgba(0,0,0,0.15)] font-display font-bold"
          style={{ color: themeColor }}
          data-testid="toggle-language"
          aria-label="Toggle language"
        >
          <Globe className="w-5 h-5" strokeWidth={3} />
          <span className="text-sm">{language.toUpperCase()}</span>
        </button>
      </div>
    </div>
  );
}
